const bodyEl: HTMLElement = document.body;
bodyEl.classList.remove('no-js');
window.addEventListener('load', () => {
  setTimeout(() => {
    bodyEl.classList.add('body--hydrated');
  }, 500);
});
